import OpenAI from 'openai';

/**
 * Validates and initializes the OpenAI client with the API key from environment variables.
 * @returns {OpenAI} Configured OpenAI client instance.
 * @throws {Error} If API key is missing or invalid
 */

// Validate API key before initializing
const apiKey = import.meta.env?.VITE_OPENAI_API_KEY;

if (!apiKey || apiKey === 'your_vite_openai_api_key' || apiKey?.trim() === '') {
  console.error('❌ OpenAI API Key is missing or invalid. Please set VITE_OPENAI_API_KEY in your .env file.');
}

const openai = new OpenAI({
  apiKey: apiKey,
  dangerouslyAllowBrowser: true, // Required for client-side usage in React
});

// Test function to verify API key works
export async function testOpenAIConnection() {
  try {
    if (!apiKey || apiKey === 'your_vite_openai_api_key') {
      throw new Error('API key not configured');
    }
    
    // Make a simple API call to test the connection
    await openai?.models?.list();
    return { success: true, message: 'OpenAI API connection successful' };
  } catch (error) {
    console.error('OpenAI connection test failed:', error);
    
    // Enhanced error message for 401 errors
    let errorMessage = error?.message || 'Failed to connect to OpenAI';
    
    if (error?.status === 401 || errorMessage?.includes('401') || errorMessage?.includes('Incorrect API key')) {
      errorMessage = '401 Authentication Error: Your OpenAI API key is invalid or expired. Please generate a new API key from https://platform.openai.com/api-keys and update your .env file with VITE_OPENAI_API_KEY=your_new_key_here';
    }
    
    return { 
      success: false, 
      message: errorMessage,
      error: error 
    };
  }
}

export default openai;
function generateOpenAIResponse(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: generateOpenAIResponse is not implemented yet.', args);
  return null;
}

export { generateOpenAIResponse };